/** Shared HTML5 drag-and-drop payload contract between AssetBin and Timeline. */
export const SCENE_DRAG_MIME = 'application/x-aquacut-scene'

export interface SceneDragPayload {
  assetId: string
  sceneIndex: number
}

export function readSceneDragPayload(dt: DataTransfer): SceneDragPayload | null {
  const raw = dt.getData(SCENE_DRAG_MIME)
  if (!raw) return null
  try {
    return JSON.parse(raw) as SceneDragPayload
  } catch {
    return null
  }
}
